/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportEntryDto } from '../../models/report-entry-dto';

export interface ReportControllerGetClientReports$Params {
  type: 'Bildung' | 'Gesundheit' | 'Standard' | 'AsylUndIntegration' | 'Freizeit' | 'Psychosoziale Entwicklung' | 'Sozio\xF6konomische Entwicklung' | 'Famili\xE4res Umfeld & soziale Kontakte';
  clientId: number;
}

export function reportControllerGetClientReports(http: HttpClient, rootUrl: string, params: ReportControllerGetClientReports$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportEntryDto>>> {
  const rb = new RequestBuilder(rootUrl, reportControllerGetClientReports.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
    rb.path('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportEntryDto>>;
    })
  );
}

reportControllerGetClientReports.PATH = '/api/report/reports/{clientId}';
